// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"cac7238d","164":"27729505","230":"1c6cf49c","241":"14a6c123","272":"30075d23","345":"afa60c0c","453":"dc9f26c2","572":"9a6f15d4","591":"024a8038","730":"bcdeb8d2","759":"4d0343dc","785":"3b2077ba"}[chunkId] + ".chunk.js";
};